/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type ListSyncedAgentUsersSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type ListSyncedAgentUsersRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
};

/** @internal */
export type ListSyncedAgentUsersSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const ListSyncedAgentUsersSecurity$outboundSchema: z.ZodMiniType<
  ListSyncedAgentUsersSecurity$Outbound,
  ListSyncedAgentUsersSecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function listSyncedAgentUsersSecurityToJSON(
  listSyncedAgentUsersSecurity: ListSyncedAgentUsersSecurity,
): string {
  return JSON.stringify(
    ListSyncedAgentUsersSecurity$outboundSchema.parse(
      listSyncedAgentUsersSecurity,
    ),
  );
}

/** @internal */
export type ListSyncedAgentUsersRequest$Outbound = {
  "Gram-Session"?: string | undefined;
};

/** @internal */
export const ListSyncedAgentUsersRequest$outboundSchema: z.ZodMiniType<
  ListSyncedAgentUsersRequest$Outbound,
  ListSyncedAgentUsersRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
    });
  }),
);

export function listSyncedAgentUsersRequestToJSON(
  listSyncedAgentUsersRequest: ListSyncedAgentUsersRequest,
): string {
  return JSON.stringify(
    ListSyncedAgentUsersRequest$outboundSchema.parse(
      listSyncedAgentUsersRequest,
    ),
  );
}
